import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { Clock, ArrowRight, Mail } from "lucide-react";

export default function PaymentPending() {
  return (
    <div className="min-h-screen bg-[#FDFBF7] flex items-center justify-center p-6">
      <Card className="max-w-lg w-full card-soft" data-testid="payment-pending-card">
        <CardContent className="p-8 text-center">
          <div className="w-20 h-20 bg-[#F59E0B] rounded-full flex items-center justify-center mx-auto mb-6">
            <Clock className="w-10 h-10 text-white" />
          </div>
          
          <h1 className="font-serif text-3xl text-[#4A4036] mb-4">
            Pago pendiente
          </h1>
          
          <p className="text-lg text-[#786C60] mb-8">
            Tu pago está siendo procesado. Esto puede tomar algunos minutos dependiendo del método de pago elegido.
          </p>
          
          <div className="bg-[#FDFBF7] rounded-xl p-6 mb-8">
            <div className="flex items-start gap-3 text-left">
              <Mail className="w-5 h-5 text-[#C47F68] flex-shrink-0 mt-1" />
              <p className="text-[#786C60]">
                Te enviaremos un email de confirmación cuando el pago sea acreditado. Si pagaste por transferencia, puede demorar hasta 24hs hábiles.
              </p>
            </div>
          </div>
          
          <Link to="/">
            <Button className="btn-primary w-full" data-testid="back-home-btn">
              Volver al inicio
              <ArrowRight className="ml-2 w-5 h-5" />
            </Button>
          </Link>
        </CardContent>
      </Card>
    </div>
  );
}
